(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const endpoint = root.dataset.endpoint;
    const family = (root.dataset.family || 'machine').trim().toLowerCase();
    const category = root.dataset.category || 'all';
    const topMarket = root.querySelector('[data-role="market-top"]');
    const finderMarket = root.querySelector('[data-role="market-finder"]');
    const form = root.querySelector('[data-role="finder-form"]');
    const topGrid = root.querySelector('[data-role="top-results"]');
    const finderGrid = root.querySelector('[data-role="finder-results"]');
    if (!endpoint || !topMarket || !form || !topGrid || !finderGrid) {
      console.warn('ROSEVIEW Top 10: required elements or endpoint missing.', root);
      return;
    }
    root.dataset.initialized = 'true';
    function normalizeMarket(value) {
      const candidate = String(value || '').trim().toUpperCase();
      return candidate === 'US' || candidate === 'CA' ? candidate : 'US';
    }
    function setSelect(select, value) {
      if (!select) return;
      const option = Array.from(select.options).find(o => o.value.toUpperCase() === value);
      if (option) select.value = option.value;
    }
    const initialMarket = normalizeMarket(root.dataset.market);
    setSelect(topMarket, initialMarket);
    setSelect(finderMarket, initialMarket);
    let topRequest = 0;
    let finderRequest = 0;
    function status(which, message) {
      const element = root.querySelector('[data-role="' + which + '-status"]');
      if (element) element.textContent = message;
    }
    function text(tag, className, value) {
      const element = document.createElement(tag);
      element.className = className;
      element.textContent = value == null ? '' : String(value);
      return element;
    }
    function card(item, index, ranked) {
      const box = text('article', 'rv-t10__card', '');
      const imageWrap = text('div', 'rv-t10__photo', '');
      if (item.image && /^https:\/\//i.test(item.image)) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || 'Amazon product';
        img.loading = 'lazy';
        imageWrap.appendChild(img);
      }
      if (ranked) imageWrap.appendChild(text('span', 'rv-t10__rank', '#' + (index + 1)));
      box.appendChild(imageWrap);
      if (item.brand) box.appendChild(text('div', 'rv-t10__brand', item.brand));
      box.appendChild(text('h3', 'rv-t10__name', item.title || 'Product'));
      box.appendChild(text('div', 'rv-t10__price', item.price || 'Check price on Amazon'));
      if (item.availability) box.appendChild(text('div', 'rv-t10__brand', item.availability));
      if (item.url && /^https:\/\/www\.amazon\.(com|ca)\//i.test(item.url)) {
        const link = text('a', 'rv-t10__button', 'View on Amazon ↗');
        link.href = item.url;
        link.target = '_blank';
        link.rel = 'sponsored nofollow noopener noreferrer';
        box.appendChild(link);
      }
      return box;
    }
    async function load(which, payload, limit) {
      const request = which === 'top' ? ++topRequest : ++finderRequest;
      const grid = which === 'top' ? topGrid : finderGrid;
      grid.replaceChildren();
      status(which, 'Searching Amazon…');
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Search service returned HTTP ' + response.status);
        const data = await response.json();
        if (data.ok === false) throw new Error(data.error || data.message || 'Search failed');
        if (request !== (which === 'top' ? topRequest : finderRequest)) return;
        const unique = new Set();
        const items = (Array.isArray(data.results) ? data.results : []).filter(item => {
          if (!item || !item.asin || unique.has(item.asin)) return false;
          unique.add(item.asin);
          return true;
        }).slice(0, limit);
        items.forEach((item, index) => grid.appendChild(card(item, index, which === 'top')));
        if (which === 'top') root.dispatchEvent(new CustomEvent('rv:top10:results', {detail:{items,marketplace:data.marketplace,market_source:data.market_source,detected_country:data.detected_country}}));
        status(which, items.length
          ? 'Showing ' + items.length + ' available products on Amazon ' + payload.marketplace + '.'
          : 'No matching products returned. Try a broader category or different marketplace.');
      } catch (error) {
        if (request !== (which === 'top' ? topRequest : finderRequest)) return;
        status(which, 'Products could not be loaded: ' + error.message + '. Please try again later.');
        console.error('ROSEVIEW Top 10 search failed:', error);
      }
    }
    function base(market) {
      const payload = {
        marketplace: normalizeMarket(market),
        subcategory: category,
        brand: root.dataset.brand || '',
        price_range: root.dataset.price || 'any'
      };
      if (family === 'food') payload.flavour = root.dataset.flavour || '';
      return payload;
    }
    topMarket.addEventListener('change', () => { try { sessionStorage.setItem('rv_market_override', normalizeMarket(topMarket.value)); } catch(_) {} setSelect(finderMarket,normalizeMarket(topMarket.value)); load('top', base(topMarket.value), 10); });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const fields = new FormData(form);
      const payload = {
        marketplace: normalizeMarket(fields.get('marketplace') || (finderMarket && finderMarket.value) || initialMarket),
        subcategory: String(fields.get('subcategory') || 'all'),
        brand: String(fields.get('brand') || ''),
        price_range: String(fields.get('price_range') || 'any')
      };
      if (family === 'food') payload.flavour = String(fields.get('flavour') || '');
      try { sessionStorage.setItem('rv_market_override',payload.marketplace); } catch(_) {} setSelect(topMarket,payload.marketplace); load('finder', payload, 20);
    });
    (async () => {
      let selected = initialMarket;
      try {
        const key = 'rv_market_override';
        const saved = sessionStorage.getItem(key);
        if (saved === 'US' || saved === 'CA') selected = saved;
        else if (family === 'machine') {
          const geoUrl = new URL(endpoint); geoUrl.pathname = '/geo';
          const response = await fetch(geoUrl.toString(), {headers:{Accept:'application/json'}});
          if (response.ok) { const geo = await response.json(); selected = normalizeMarket(geo.marketplace); }
        }
      } catch (error) { console.warn('ROSEVIEW geolocation unavailable, using default market', error); }
      setSelect(topMarket, selected); setSelect(finderMarket, selected);
      load('top', base(selected), 10);
    })();
  }
  function initializeAll() {
    document.querySelectorAll('[data-rv-top10-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
